import { useState } from "react";
import { Navbar, Nav, Container, Image } from "react-bootstrap";
import ArrowIcon from "../components/svg/arrow";
import { useNavigate, useLocation } from "react-router-dom";
import Popper from "../components/popper";
import "../utils/tailwind.css";
import Const from "../utils/constant";
import NofificationDrawer from "./components/notification-drawer";
import userImage from "../assets/images/user.png";
import ProfilePicture from "./components/profile-picture";
import BackIcon from "../components/svg/back";
import Modal from "../components/modal";
import { useStore } from "../utils/context";

export default function AppNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { handleLogout } = useStore();
  const [isModalOpen, setIsOpenModal] = useState(false);
  const handleBackClick = () => {
    const currentPath = location.pathname;
    if (currentPath.startsWith("/addwork/")) {
      navigate("/work");
    } else {
      navigate(-1);
    }
  };

  const showBackButton = Const.BACK_BUTTON_SCREENS.includes(location.pathname);

  const handleLogoutClick = () => {
    handleLogout();
  };

  return (
    <Navbar bg="white" variant="white" expand="lg" className="p-2 py-3 w-full">
      <Modal
        title="Confirm"
        desc="Are you sure you want to logout ?"
        isModalOpen={isModalOpen}
        setIsOpen={setIsOpenModal}
        handleSubmit={handleLogoutClick}
        confirmButtonLabel="Logout"
      />
      <NofificationDrawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} />
      <ProfilePicture isOpen={isProfileOpen} setIsOpen={setIsProfileOpen} />
      <Container fluid>
        <div
          role="button"
          tabIndex={0}
          className="flex  ml-[15rem]  items-center space-x-2 cursor-pointer p-2 px-4 hover:bg-[#000000] hover:text-white rounded-md transition-colors duration-200"
          onClick={handleBackClick}
        >
          <ArrowIcon className="rotate-180" />
          <span className=" ">Back</span>
        </div>
        <Nav className="ms-auto d-flex align-items-center !justify-between space-x-8">
          <Popper placement="bottom" setIsOpen={setIsPopperOpen} isOpen={isPopperOpen} onOutsideClick={() => setIsPopperOpen(false)}>
            <Popper.Trigger>
              {({ setAnchorElement }) => (
                <div ref={setAnchorElement}>
                  <Image src={userImage} roundedCircle width="40" height="40" className="me-2 cursor-pointer" onClick={() => setIsPopperOpen(true)} />
                </div>
              )}
            </Popper.Trigger>
            <Popper.Content>
              <div className="p-3 w-[360px] h-[135px] rounded-[8px] bg-white border-[1px] border-[#F0F0F0] shadow-[0px_14px_54px_0px_rgba(0,0,0,0.1)] mr-9 mt-2.5">
                <div className="flex space-x-4 items-center">
                  <div className="w-[65px] h-[65px] rounded-full bg-[#EDFBF0] flex justify-center items-center">
                    <div className="text-[25px] text-[#1E542A]">A</div>
                  </div>
                  <div className="text-[16px] text-[#2C2C2C]">Admin</div>
                </div>
                <div role="button" tabIndex={0} className="flex space-x-3 mt-3 cursor-pointer" onClick={() => setIsOpenModal(true)}>
                  <BackIcon className="text-black" />
                  <span className="text-[#FB325E] text-[16px]">Logout</span>
                </div>
              </div>
            </Popper.Content>
          </Popper>
        </Nav>
      </Container>
    </Navbar>
  );
}
